export { AvatarSize, User } from './user-avatar.component';
